import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { client, apiEndpoints } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import { serverUrl } from "../../config";
import { decodeHtmlEntities } from "../../utils/helpers";

import { Typography, Button } from "@mui/material";
import ChevronRight from '@mui/icons-material/ChevronRightOutlined';
import { CircularProgress } from "@mui/material";
import ClearIcon from '@mui/icons-material/ClearOutlined';
import { Row, Col } from "react-bootstrap";

export default function SearchItem(props) {

  const [uri, setUri] = useState("");
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const user = useSelector((state) => state).authReducer.user;

  useEffect(() => {
    if (props.item.type === 'documents' ||
      props.item.type === 'Documents' ||
      props.item.type === 'document' ||
      props.item.type === 'Document') {
      setIsLoading(true);
      fetchDocument(props.item.nid);
    }
    if (props.item.type === 'external_resource' ||
      props.item.type === 'External Resource' ||
      props.item.type === 'link' ||
      props.item.type === 'Link') {
      setIsLoading(true);
      fetchLink(props.item.nid);
    }
    // eslint-disable-next-line
  }, [props.item]);

  const fetchDocument = (nid) => {
    let path = `${apiEndpoints.documents}/all/${nid}`;
    getOnlineNode(path, user.access_token)
      .then((response) => {
        setIsLoading(false);

        if (response?.data?.rows[0]?.uri) {
          setUri(response?.data?.rows[0]?.uri);
        }

        if (response?.data?.rows[0]?.field_document) {
          setUri(response?.data?.rows[0]?.field_document);
        }
      })
      .catch((_error) => {
        setIsLoading(false);
        setError(true);
      });
  }

  const fetchLink = (nid) => {
    let path = `${apiEndpoints.links}/all/${nid}`;
    getOnlineNode(path, user.access_token)
      .then((response) => {
        if (response?.data?.rows[0]?.field_url) {
          setUri(response?.data?.rows[0]?.field_url);
        }

        if (response?.data?.rows[0]?.url) {
          setUri(response?.data?.rows[0]?.url);
        }

        setIsLoading(false);

      })
      .catch((_error) => {
        setIsLoading(false);
        setError(true);
      });
  }


  const handleLink = () => {
    switch (props.item.type) {
      case "News": {
        navigate(`/news/${props.item.nid}`);
        break;
      }
      case "Event":
      case "Events": {
        navigate(`/events/${props.item.nid}`);
        break;
      }
      case "Video":
      case "Videos": {
        navigate(`/videos/${props.item.nid}`);
        break;
      }
      case "Podcast":
      case "Podcasts": {
        navigate(`/podcasts/${props.item.nid}`);
        break;
      }
      case "Gallery":
        navigate(`/galleries/${props.item.nid}`);
        break;
      case "Course": {
        const trainingId = client === "equans" ? props.item.nid : (props.item.id || props.item.nid);
        navigate(`/training/${trainingId}`);
        break;
      }
      case "Quiz": {
        navigate(`/quizzes/${props.item.nid}`);
        break;
      }
      case "Document":
      case "Documents": {
        if (uri) {
          window.open(serverUrl + uri, "_blank");
        }
        break;
      }
      case "Link":
      case "External Resource":
        window.open(uri, "_blank");
        break;
      case "Company Directory":
        navigate(`/company_directory/${props.item.nid}`);
        break;
      case "Webform": {
        props.showForm({ title: props.item.title, id: props.item.nid });
        break;
      }
      default:
        return;
    }
  }

  const iconSize = 20;

  return (
    <Button
      className="w-100 d-flex justify-content-between align-items-center my-1"
      variant="searchItem"
      owner="client"
      lineHeight="wide"
      onClick={() => handleLink()}
      endIcon={
        error ?
          <ClearIcon
            sx={{ fontSize: `${iconSize}px` }}
          /> :
          isLoading ?
            <CircularProgress
              color="clientPrimary"
              size={iconSize}
            /> :
            <ChevronRight
              sx={{ fontSize: `${iconSize}px` }}
            />
      }
    >
      <Row className="w-100">
        <Col xs={10} sm={8} md={10}>
          <Typography
            family="secondary"
            className="text-start"
            owner="client"
            variant="subtitle1"
            lh="semi-wide"
            weight="medium"
          >
            {decodeHtmlEntities(props.item.title)}
          </Typography>
        </Col>
      </Row>
    </Button>
  )
}